import * as types from '../mutation-types';
const state = {
  uploadMsg: {}, // 上传和解密
  parseMsg: {}, // 解析
  decryptTimeStart: false, // 是否開始解密
  decryptTimeEnd: false, // 是否结束解密
};

const getters = {
  getUploadMsg: (state) => state.uploadMsg,
  getParseMsg: (state) => state.parseMsg,
  getDecryptEnd: (state) => state.decryptTimeEnd,
  getDecryptStart: (state) => state.decryptTimeStart,
};

const actions = {
  async updateDecrypt({ commit }, obj) {
    commit(types.GET_UPDATEMSG_STATUS, obj);
  },
  async updateParse({ commit }, obj) {
    commit(types.GET_BIDDERPARSE_STATUS, obj);
  },
  async updateDecryptTimeStart({ commit }, obj) {
    commit(types.GET_DIERYPTSTART_STATUS, obj);
  },
  async updateDecryptTimeEnd({ commit }, obj) {
    commit(types.GET_DIERYPTEND_STATUS, obj);
  },
};

const mutations = {
  [types.GET_UPDATEMSG_STATUS](state, obj) {
    state.uploadMsg = obj;
  },
  [types.GET_BIDDERPARSE_STATUS](state, obj) {
    state.parseMsg = obj;
  },
  [types.GET_DIERYPTEND_STATUS](state, obj) {
    state.decryptTimeEnd = obj;
  },
  [types.GET_DIERYPTSTART_STATUS](state, obj) {
    state.decryptTimeStart = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
